import { Decorator } from 'final-form'
import createDecorator from 'final-form-calculate'

import { INITIAL_VALUES } from './constants'

export const customerAddDecorator = [
  createDecorator({
    field: 'company',
    updates: (_, __, allValues) => {
      const tAllValues = allValues as typeof INITIAL_VALUES

      return {
        ...allValues,
        address: tAllValues.addressSuggestorDisabled ? INITIAL_VALUES.address : tAllValues.address
      }
    }
  }) as Decorator<typeof INITIAL_VALUES>
]
